import { SpeakButton } from "@/components/SpeakButton";
import { MicButton } from "@/components/MicButton";

export const SoundsSection = ({ sounds, lang }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-slate-900 mt-10 mb-1">Key sounds</h2>
    <p className="text-sm text-slate-500 mb-4">Listen, copy the tip, then tap the mic to check yourself.</p>
    <div className="grid sm:grid-cols-2 gap-3">
      {sounds.map((s, i) => (
        <div key={i} data-testid={`sound-card-${i}`} className="rounded-2xl bg-white border border-slate-200 p-4">
          <div className="flex items-center gap-3">
            <span className="min-w-[3.5rem] h-14 px-2 rounded-2xl bg-[hsl(var(--secondary-light))] text-[hsl(var(--secondary-dark))] grid place-items-center font-display text-2xl font-extrabold">{s.sound}</span>
            <p className="text-sm text-slate-700 flex-1">{s.how}</p>
          </div>
          <div className="mt-3 flex items-center gap-2 rounded-xl bg-slate-50 p-2.5">
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-slate-900">{s.example}</p>
              {s.romaji && <p className="text-xs text-[hsl(var(--accent-blue))] font-semibold">{s.romaji}</p>}
              <p className="text-xs text-slate-500">{s.translation}</p>
            </div>
            <SpeakButton text={s.example} lang={lang} testId={`sound-speak-${i}`} />
            <MicButton text={s.example} romaji={s.romaji} lang={lang} testId={`sound-mic-${i}`} />
          </div>
        </div>
      ))}
    </div>
  </section>
);
